import DetailBDS from "./DetailBDS";
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const DetailAreas = ({data}) => {
  const {project, building, adaptation, areas} = data || {};

  // Active area + keyed lazy mount (mountOnEnter semantics): an area's BDS
  // content mounts only when its tab is first opened, then stays mounted and
  // is hidden with tw-hidden. Keyed by area.id so data refreshes never
  // remount other areas' content.
  const [activeAreaId, setActiveAreaId] = useState(areas?.[0]?.id ?? null)
  const mountedIdsRef = useRef(new Set(activeAreaId != null ? [activeAreaId] : []))
  if (activeAreaId != null) mountedIdsRef.current.add(activeAreaId)

  // If the active area no longer exists, fall back to the first area
  useEffect(() => {
    if (areas?.length && !areas.some(area => area.id === activeAreaId)) {
      setActiveAreaId(areas[0].id)
    }
  }, [areas, activeAreaId])

  return (
    <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-200 tw-rounded-lg tw-overflow-hidden">
      <div className="tw-flex tw-flex-col md:tw-flex-row">
        <div className="md:tw-w-2/12 tw-border-0 md:tw-border-r tw-border-solid tw-border-slate-200">
          <nav className="tw-flex md:tw-flex-col tw-gap-1 tw-p-2 tw-overflow-x-auto">
            {areas && areas.map((area) => (
              <button
                key={area.id}
                type="button"
                onClick={() => setActiveAreaId(area.id)}
                className={`tw-text-left tw-px-3 tw-py-2 tw-rounded tw-text-sm tw-font-medium tw-border-0 tw-cursor-pointer tw-transition-colors tw-whitespace-nowrap ${
                  area.id === activeAreaId
                    ? 'tw-bg-primary-600 tw-text-white'
                    : 'tw-bg-transparent tw-text-slate-600 hover:tw-bg-slate-100'
                }`}
              >
                Area {area.id}
              </button>
            ))}
          </nav>
        </div>
        <div className="md:tw-w-10/12 tw-bg-slate-50 tw-p-4">
          {areas && areas.filter(area => mountedIdsRef.current.has(area.id)).map((area) => (
            <div key={area.id} className={area.id === activeAreaId ? '' : 'tw-hidden'}>
              <DetailBDS
                project={project}
                building={building}
                adaptation={adaptation}
                area={area}
                areaIndex={areas.findIndex((a) => a.id === area.id)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
};

DetailAreas.propTypes = {
  data: PropTypes.shape({
    project: PropTypes.object,
    building: PropTypes.object,
    adaptation: PropTypes.object,
    areas: PropTypes.array
  }).isRequired
}

export default DetailAreas;
